import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, from as fromPromise, Observable } from 'rxjs/index';
import { map, tap } from 'rxjs/operators';
import { BackendAPIService } from '../core/backend-api.service';
import { Conversation } from '../modules/two-way/shared/conversation.model';
import { ConversationsState } from '../modules/two-way/shared/conversations-state.model';
import { TwoWayMessagesState } from '../modules/two-way/shared/two-way-messages-state.model';
import { Person } from '../modules/two-way/shared/two-way-person.model';
import { TwoWaySettingsModel } from '../modules/two-way/shared/two-way-settings.model';
import { LoadingIndicator } from '../shared/loading-indicator';
import { UserProfileService } from './user/user.profile.service';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class TwoWayService {

    public conversation$: BehaviorSubject<Conversation> = new BehaviorSubject<Conversation>(undefined);

    public conversationsState$: BehaviorSubject<ConversationsState> = new BehaviorSubject({
        lastModifiedTs: 0,
        doNotProcess: true
    });

    // public searchConversation$: BehaviorSubject<Conversation> = new BehaviorSubject<Conversation>(undefined);

    public refreshMessages$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

   // public refreshConversations$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);

    public containerHeight$: BehaviorSubject<number> = new BehaviorSubject<number>(undefined);

    public messagesSearchText$: BehaviorSubject<String> = new BehaviorSubject<String>('');

    public refreshedSuccessFlag$: BehaviorSubject<boolean> = new BehaviorSubject(true);

    public twoWaySettings$: BehaviorSubject<TwoWaySettingsModel> = new BehaviorSubject(undefined);
    public currentUser: any;
    private twoWayServletUrl = 'servlets/two-way';
    private logEventServletUrl = 'servlets/log-event/log/event/';
    private stubConversation: Conversation = {
        destinatorIds: [0],
        isSearchStub: true,
        personIds: [0]
    };

    constructor(private userProfileService: UserProfileService,
                private backendAPIService: BackendAPIService,
                private httpClient: HttpClient
    ) {
    }

    private _disableErrorDialog = true;

    // private _conversationListCapacity = 8;
    //
    // get conversationListCapacity(): number {
    //     return this._conversationListCapacity;
    // }
    //
    // set conversationListCapacity(value: number) {
    //
    //     if (value < 4) {
    //         value = 4;
    //     }
    //     if (value > 8) {
    //         value = 8;
    //     }
    //
    //     this._conversationListCapacity = value;
    // }
    //
    //  public resetState(): void {
    //     this.getState()
    //         .resetTemporary();
    // }
    //
    // public select(paramName: string): any {
    //     return this.getState()
    //         .get(paramName);
    // }
    //
    // public update(paramName: string, value: any, isGlobalScope?: boolean): void {
    //     if (isGlobalScope !== undefined && isGlobalScope !== null && isGlobalScope === true) {
    //         this.getState()
    //             .setGlobal(paramName, value);
    //     } else {
    //         this.getState()
    //             .setTemporary(paramName, value);
    //     }
    // }

    // private getState(): TwoWayState {
    //     if (this.state === null) {
    //         this.state = new TwoWayState();
    //     }
    //
    //     return this.state;
    // }

    set disableErrorDialog(value: boolean) {
        this._disableErrorDialog = value;
    }

    private _userId: number;

    set userId(value: number) {
        this._userId = value;
    }

    public getStubConversation(): Conversation {
        return this.stubConversation;
    }

    public getConversations(params: object, loadingIndicator: object): Observable<any> {
        const payLoad = this.compileConversationsParams(params);

        return fromPromise(
            this.backendAPIService.request(
                'post',
                `${this.twoWayServletUrl}/conversations/`,
                {
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Failed getting conversations from server',
                    disableErrorDialog: this._disableErrorDialog,
                    retryBtn: false,
                    body: payLoad
                },
                loadingIndicator)
                .then((response: any): any => {
                    console.log('service.getConversations(): Conversations fetched');

                    return response;
                })
                .catch((error: any) =>
                    Promise.reject(error))
        );
    }

    /*
    public getUpdatedConversations(state: ConversationsState, loadingIndicator?: object): Observable<Array<Conversation>> {
        // const loadingIndicator: LoadingIndicator = {state: false, refCount: 0};
        this.refreshedSuccessFlag$.next(false);

        const body = {
            personId: state.personId,
            // destinatorId:
            getModified: true,
            lastModifiedTs: state.lastModifiedTs
            // offset: state.offset,
        };

        return fromPromise(
            this.backendAPIService.request(
                'post',
                `${this.twoWayServletUrl}/conversations/`,
                {
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Failed getting fresh conversations from server',
                    disableErrorDialog: false,
                    retryBtn: false,
                    body
                }, loadingIndicator)
                .then((response: any): Array<Conversation> => {
                    console.log('service.getUpdatedConversations(): Conversations fetched');
                    if (response !== undefined) {
                        this.refreshedSuccessFlag$.next(true);
                    }

                    return response.conversations;
                })
                .catch((error: any) =>
                    Promise.reject(error))
        );
    }
*/
    public getMessages(messagesState: TwoWayMessagesState, loadingIndicator: LoadingIndicator): Observable<TwoWayMessagesState> {
        this.refreshedSuccessFlag$.next(false);
        const body = {
            personId: messagesState.conversation.personIds[0],
            destinatorId: messagesState.conversation.destinatorIds[0],
            personPhone: messagesState.conversation.personPhone,
            phoneAsInGateway: messagesState.conversation.phoneAsInGateway,
            firstId: messagesState.firstId,
            getModified: messagesState.getModified || false,
            lastModified: messagesState.lastModified,
            lastModifiedLong: messagesState.lastModifiedLong,
            keywords: this.messagesSearchText$.getValue() // TODO: Get into state from caller
        };

        return fromPromise(
            this.backendAPIService.request(
                'post',
                `${this.twoWayServletUrl}/messages/`,
                { // TODO: Remove retryBtn, disableErrorDialog, errorMessage from data posted to backend
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Failed getting messages from server',
                    disableErrorDialog: this._disableErrorDialog,
                    retryBtn: true,
                    body
                }, loadingIndicator)
                .then((response: any): TwoWayMessagesState => {
                    console.log(`TwoWay messages fetched for destinator [${messagesState.conversation.destinatorIds[0]}]`);
                    if (response !== undefined) {
                        this.refreshedSuccessFlag$.next(true);
                    }

                    return response;
                })
                .catch((error: any) =>
                    Promise.reject(error))
        );
    }

    /**
     * Get media device from current user settings
     */
    public getMediaDevice(user): string {
        let deviceId = 'sms|twilio|0'; // Default
        try {
            deviceId = user.media
                .filter(i => (i as any).type === 'sms')
                .map(media => (media as any).device)[0];
        } catch (e) {
            console.log('No current user or default sms device for user', user);
        }

        return deviceId;
    }

    public sendMessage(personId: number, destinator: string, phoneAsInGateway: string, destinatorId: number,
                       user: any, messageText: string, loadingIndicator): Observable<any> {
        const deviceId: string = this.getMediaDevice(user);

        const messageBody = {
            personId,
            destinator,
            deviceId,
            messageText,
            destinatorId
        };

        const promise = this.backendAPIService.request(
            'post',
            `${this.twoWayServletUrl}/message/`,
            {
                headers: {'Content-Type': 'application/json'},
                errorMessage: 'Failed adding a message',
                disableErrorDialog: false,
                retryBtn: true,
                body: messageBody
            },
            loadingIndicator)
        ;

        return fromPromise(promise);
    }

    markMessageSeen(messageDataIds: Array<number>): Observable<any> {
        const body = {
            messageDataIds
        };
        return this.httpClient
            .post(`${this.twoWayServletUrl}/seen/`, {messageDataIds})
            .pipe( tap (response => this.refreshMessages$.next({refreshNotOnNew: false}))
            );
    }

    public markMessageSeenOld(messageDataIds: Array<number>, loadingIndicator): Observable<any> {
        const body = {
            messageDataIds
        };

        const promise = this.backendAPIService.request(
            'post',
            `${this.twoWayServletUrl}/seen/`,
            {
                headers: {'Content-Type': 'application/json'},
                errorMessage: 'Failed marking messages as seen',
                disableErrorDialog: true,
                retryBtn: false,
                body
            },
            loadingIndicator);

        return fromPromise(promise);
    }

    // TODO: Should we use interface like IParams instead object?
    compileConversationsParams(data: object): object {

        const params = {};

        (params as any).userId = this._userId;
        (params as any).limit = (data as any).limit !== undefined ? (data as any).limit : 5;
        (params as any).offset = (data as any).offset !== undefined ? (data as any).offset : 0;

        (params as any).lastModifiedTs = (data as any).lastModifiedTs !== undefined ? (data as any).lastModifiedTs : 0;
        (params as any).getModified = (data as any).getModified !== undefined ? (data as any).getModified : false;

        // if ((data as any).limit !== undefined) {
        //     (params as any).limit = (data as any).limit;
        // }

        // if ((data as any).offset !== undefined) {
        //     (params as any).offset = (data as any).offset;
        // }

        if ((data as any).personIds !== undefined && +(data as any).personIds[0] > 0) {
            (params as any).personId = (data as any).personIds[0];
        }

        if ((data as any).destinatorIds !== undefined && (data as any).destinatorIds[0] + ''.length > 0) {
            (params as any).destinatorId = (data as any).destinatorIds[0];
        }

        return params;
    }

    public getPersonsAndDestinator(searchString: string, loadingIndicator: object): Observable<Array<Person>> {
        this.refreshedSuccessFlag$.next(false);

        return fromPromise(
            this.backendAPIService.request(
                'get',
                `${this.twoWayServletUrl}/person/search/?searchParam=${searchString}`,
                {
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Failed getting person and destinator',
                    disableErrorDialog: this._disableErrorDialog,
                    retryBtn: true
                }, loadingIndicator)
                .then((response: any): Array<Person> => {
                    console.log('Persons and Destinator found ');

                    if (response.persons !== undefined) {
                        this.refreshedSuccessFlag$.next(true);

                        return response.persons;
                    }
                })
                .catch((error: any) =>
                    Promise.reject(error))
        );
    }

    getUserTwoWaySetting(loadingIndicator: LoadingIndicator): Observable<TwoWaySettingsModel> {
        return fromPromise(
            this.backendAPIService.request(
                'GET',
                `${this.twoWayServletUrl}/user/settings/`,
                {
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Failed getting user Two Way settings from server',
                    disableErrorDialog: false,
                    retryBtn: true
                }, loadingIndicator)
                .then((response: any): TwoWaySettingsModel => {

                    let twoWaySettings: TwoWaySettingsModel = {
                        predefinedMessages: []
                    };

                    if (response !== undefined && response.twoway !== undefined) {
                        twoWaySettings = response.twoway as TwoWaySettingsModel;
                    }

                    this.twoWaySettings$.next(twoWaySettings);

                    return twoWaySettings;
                })
                .catch((error: any) => {

                    this.initPredefinedMessages();

                    return Promise.reject(error);
                })
        );
    }

    /**
     * Something like an action
     */
    public refreshUserTwoWaySetting(loadingIndicator: LoadingIndicator): void {

        this.getUserTwoWaySetting(loadingIndicator)
            .subscribe(result => {
                this.twoWaySettings$.next(result);
            });
    }

    private initPredefinedMessages(): void {
        if (this.twoWaySettings$.getValue() === undefined || this.twoWaySettings$.getValue().predefinedMessages === undefined) {
            this.twoWaySettings$.next({predefinedMessages: []});
        }
    }

    updateUserTwoWaySetting(twoWaySetting: TwoWaySettingsModel, loadingIndicator: object): Observable<TwoWaySettingsModel> {
        const body = {
            twoway: twoWaySetting
        };

        return fromPromise(
            this.backendAPIService.request(
                'PUT',
                `${this.twoWayServletUrl}/user/settings/`,
                {
                    headers: {'Content-Type': 'application/json'},
                    errorMessage: 'Unable to update Two-Way Settings',
                    disableErrorDialog: false,
                    retryBtn: true,
                    body
                }, loadingIndicator)
                .then((response: any): TwoWaySettingsModel => {
                    console.log('Update Two way Settings ');

                    let twoWaySettings: TwoWaySettingsModel = {};

                    if (response.twoway !== undefined) {
                        twoWaySettings = response.twoway as TwoWaySettingsModel;
                        this.twoWaySettings$.next(twoWaySettings);
                    }

                    return twoWaySettings;
                })
                .catch((error: any) => {
                    console.log('Saving twoWaySetting error', error);

                    return Promise.reject(error);
                })
        );
    }

    getConversationsCount(httpHeaders?: HttpHeaders): Observable<number> {
        return this.httpClient
            .get('servlets/two-way/conversations/count/', {observe: 'body'})
            .pipe(
                map((response: any) => response.totalConversationCount)
            );
    }

}
